// Junta las escrituras de una sesión: la evaluación y la sesión se releen una vez, al final.
const inFlight = new Map<string, number>();
const dirty = new Set<string>();

export function startWrite(sessionId: string): void {
    inFlight.set(sessionId, (inFlight.get(sessionId) ?? 0) + 1);
}

/** Cierra una escritura; si fue la última y alguna cambió algo, corre `flush` una sola vez. */
export function finishWrite(sessionId: string, changed: boolean, flush: () => void): void {
    const left = Math.max(0, (inFlight.get(sessionId) ?? 1) - 1);
    inFlight.set(sessionId, left);
    if (changed) dirty.add(sessionId);
    if (left > 0 || !dirty.has(sessionId)) return;
    dirty.delete(sessionId);
    flush();
}
